import { Row, Col, Checkbox, Flex } from "antd";
import { useEffect, useState } from "react";

type Props = {
  onChange?: (value: number[]) => void;
  initialValue?: number[];
};

const weekDays = [
  { id: 0, name: "S" },
  { id: 1, name: "M" },
  { id: 2, name: "T" },
  { id: 3, name: "W" },
  { id: 4, name: "T" },
  { id: 5, name: "F" },
  { id: 6, name: "S" },
];

function WeekDaysCheckBoxes({ onChange, initialValue }: Props) {
  const [checkedList, setCheckedList] = useState<number[]>([]);

  useEffect(() => {
    if (initialValue) setCheckedList(initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => {
      onChange?.(checkedList);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [checkedList]
  );

  return (
    <Row justify="space-evenly">
      {weekDays.map((day, index) => (
        <Col span={3} key={index}>
          <Row>
            <Col span={24}>
              <Flex justify="center">{day.name}</Flex>
            </Col>
            <Col span={24}>
              <Flex justify="center">
                <Checkbox
                  checked={checkedList.includes(day.id)}
                  onChange={(value) => {
                    if (value.target.checked)
                      setCheckedList([...checkedList, day.id]);
                    else
                      setCheckedList(checkedList.filter((id) => id !== day.id));
                  }}
                />
              </Flex>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  );
}

export default WeekDaysCheckBoxes;
